module.exports = __webpack_public_path__ + "static/bubble-with-negative-values-c561925794af9da8639d5cde149f5cfa.png";